import { useContext, useEffect, useState } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
import UI_NavigationRail_Item from "./UI_NavigationRail_Item";
import Icon_Hamburger from '../../Assets/Icons/Icon_Hamburger.png';
export default function UI_NavigationRail({ Composition }) {
    const UI = useContext(Context_UI);
    const [isExpanded, isExpanded_Set] = useState(false);
    let root = document.documentElement;
    useEffect(() => {
        if (isExpanded) {
            root.style.setProperty("--Panels-Margin-Left", root.style.getPropertyValue("--Panel-Navigation-Rail-Width-Expanded"));
        } else {
            root.style.setProperty("--Panels-Margin-Left", root.style.getPropertyValue("--Panel-Navigation-Rail-Width-Collapsed"));
        }
    }, [isExpanded])
    return (
        <>
            <ui-navigationrail id="NavigationRail" State={isExpanded ? "Expanded" : "Collapsed"}>
                <button className='NavigationRail_Item NavigationRail_Toggle' onClick={() => {
                    // UI.Navigation_Toggle();
                    isExpanded_Set(!isExpanded)
                }}>
                    <img className='NavigationRail_Toggle_Icon' src={Icon_Hamburger} draggable='false' loading='lazy' alt='' />
                </button>
                {Composition ? 
                    <>
                        {Composition.map((Item, Index) => (
                            <>
                                {Item.Active() ?
                                    <UI_NavigationRail_Item
                                        key={Index}
                                        Destination={Item.Destination}
                                        Icon={Item.Icon}
                                        Text={Item.Text}
                                        hasBadge={Item.hasBadge}
                                        LoadingScreen={Item.LoadingScreen}
                                    />
                                    :
                                    ""
                                }
                            </>

                        ))}
                    </>
                    :
                    ""
                }
                
            </ui-navigationrail>

        </>
    )
}

